import mapboxgl from 'mapbox-gl'
import { Component, Vue } from 'nuxt-property-decorator'

@Component
export default class Seasons extends Vue {
  map: mapboxgl.Map

  setupSeasons(map: mapboxgl.Map) {
    this.map = map
  }

  switchSeason(summer: boolean = true) {
    const summerLayers = this.map
      .getStyle()
      .layers.filter((layer) => layer.id.includes('summer-'))
      .map((layer) => layer.id)

    const winterLayers = this.map
      .getStyle()
      .layers.filter((layer) => layer.id.includes('winter-'))
      .map((layer) => layer.id)

    if (summer) {
      this.setLayersVisibility(summerLayers, 'visible')
      this.setLayersVisibility(winterLayers, 'none')
    } else {
      this.setLayersVisibility(summerLayers, 'none')
      this.setLayersVisibility(winterLayers, 'visible')
    }
  }

  setLayersVisibility(layers: Array<string>, visibility: string) {
    layers.forEach((layer) => {
      if (this.map.getLayer(layer)) {
        this.map.setLayoutProperty(layer, 'visibility', visibility)
      }
    })
  }
}
